import React,{ useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import { utcToLocal } from "../../../helpers/DateHelper";
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function ReportTable({
    module,
    data,
    loading,
    totalRows,
    candidateStatuses,
    // isTrash,
    // limit,
    // page,
}) {

    const columns = [
        {
            name: "#",
            selector: (row, index) => index +1 ,
            width: '80px'
        },
        {
            name: <div title="Client Name">Client Name</div>,
            selector: (row) => row.client_name_with_gstin,
            width: '200px',
            wrap: true,
            grow: 2, // optional, allows wider columns
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            }
        },
        {
            name: <div title="Active Positions">Active Positions</div>,
            selector: (row) => row.active_positions ? row.active_positions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="On Hold">On Hold</div>,
            selector: (row) => row.on_hold_positions ? row.on_hold_positions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Closed">Closed</div>,
            selector: (row) => row.closed_positions ? row.closed_positions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Total Submissions">Total Submissions</div>,
            selector: (row) => row.total_submissions ? row.total_submissions : 0,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Total Interviews">Total Interviews</div>,
            selector: (row) => row.total_interviews,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div>No Show</div>,
            selector: (row) => row.no_show_count,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        // Dynamically add status columns
        ...candidateStatuses.map(status => ({
            name: <div title={status.status_name}>{status.status_name}</div>,
            selector: (row) => row[`status_name_${status._status_id}`] ?? 0,
            wrap: true,
            grow: 2, // optional, allows wider columns
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            },
        })),
        {
            name: <div>Sub-Hit Ratio</div>,
            selector: (row) => row.interview_position_ratio,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
    ];

    const { theme, toggleTheme } = useTheme();

    // useEffect(() => {
    //     fetchData(limit, page);
    // }, []);

    createTheme("dark", {
        text: {
            primary: "#a2a3a4",
            secondary: "#2aa198",
        },
        background: {
            default: "#252729",
        },
        context: {
            background: "#cb4b16",
            text: "#a2a3a4",
        },
        divider: {
            default: "#073642",
        },
        action: {
            button: "rgba(0,0,0,.54)",
            hover: "rgba(0,0,0,.08)",
            disabled: "rgba(0,0,0,.12)",
        },
    });

    return (
        <div style={{ overflowX: "auto", width: "100%" }}>
  <div style={{ minWidth: "1600px" }}> {/* 👈 forces the table to be wide enough */}
    
        <DataTable
        // title={`Manage Notes (Private)`}
            className="clickable cms-data-table"
            columns={columns}
            data={data}
            paginationServer
            paginationTotalRows={totalRows}
            progressPending={loading}
            progressComponent={<TableLoader noOfColumn={columns.length} />}
            fixedHeader
            fixedHeaderScrollHeight="75vh"
            highlightOnHover
            paginationPerPage={10}  // default page size
            paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
            theme={`${theme === "light" ? "light" : "dark"}`}
            customStyles={getCmsDataTableStyles(theme)}
        />
        </div>
        </div>
    );
};